import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-actions',
  templateUrl: './page-actions.component.html',
  styleUrls: ['./page-actions.component.scss']
})
export class PageActionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
